import compass from '../openapi_compass_external.txt';
import { RedocStandalone } from 'redoc';

function Compass() {
  return (
    <div className="CompassFull">
      <RedocStandalone spec={compass} />
    </div>
  );
}

export default Compass;
